import { getFirestore, getDoc, setDoc, doc } from "firebase/firestore"
import { toFirebaseSafeObject } from "utils/general";


const getDbRef = (projectId: string) => {
    const db = getFirestore()
    const docRef = doc(db, "mini_db", projectId);
    return docRef;
}


const miniDbSetDoc = async (projectId: string, data: any) => {
    try {
        const docRef = getDbRef(projectId);
        const key = data.get("key");
        const value = toFirebaseSafeObject(data.get("value"));
        await setDoc(docRef, {
            [key]: value
        }, { merge: true });
    } catch (error) {
        console.error('DB Set Doc Error', error);
        return {
            response: null,
            error: "Error setting document"
        }
    }
    return {
        response: true,
        error: null
    };
}


const miniDbGetDoc = async (projectId: string, data: any) => {
    console.log(data);
    try {
        const key = data.get("key");
        const docRef = getDbRef(projectId);
        const docSnap = await getDoc(docRef);
        console.log(key, docSnap.exists());

        if (docSnap.exists()) {
            
            const docData = docSnap.data();
            if (key && key in docData) {
                return {
                    response: docData[key],
                    error: null
                }
            } else {
                return { 
                    response: null,
                    error: null
                }
            }
        } else {
            return {
                response: null,
                error: null
            }
        }
    } catch (error) {
        console.error('DB Get Doc Error', error)
        return { 
            response: null,
            error: "Error getting document"
        }
    }
}


const miniDbListDocs = async (projectId: string, data: any) => {
    try {
        const docRef = getDbRef(projectId);
        if (!docRef) {
            return {
                response: [],
                error:  null
            }
        }

        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            let keys = Object.keys(data);
            // sort the keys
            keys = keys.sort((a, b) => {
                return a.localeCompare(b);
            });

            return {
                response: keys,
                error: null
            }
        } else {
            return {
                response: [],
                error: null
            }
        }
    } catch (error) {
        console.error('DB List Docs Error', error)
        return {
            response: null,
            error: "Error listing documents"
        }
    }
}


export const delegateRequest = async (projectId: string, data: any, requestType: string) => {
    try {
        switch (requestType) {
            case "set":
                return await miniDbSetDoc(projectId, data);
            case "get":
                return await miniDbGetDoc(projectId, data);
            case "list":
                return await miniDbListDocs(projectId, data);
            default:
                return {
                    error: "Invalid request type",
                    data: {}
                }
        }
    } catch (error) {
        return {
            error: "Error in delegateRequest",
            data: {}
        }
    }

}